import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'datestringfrommillis'})
export class DateStringFromMillisPipe implements PipeTransform {

    pad(num:number, size:number, paddingChar:string): string {
        var s = num+"";
        while (s.length < size) s = paddingChar + s;
        return s;
    }

    transform(value: string): string {

        let date = new Date(value);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        
        return this.pad(day, 2, "0")+"/"+this.pad(month, 2, "0")+"/"+this.pad(year, 2, "0");
        
    }

}
